export default __webpack_public_path__ + "static/media/BT_Icons_User_White.5416c6af.svg";